/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import * as colors from '../colors';
import { qtmBlack, QtmPalette, qtmWhite, setGreyAliases } from './Palette';

/** Palette of colors for light theme */
export const qtmDarkThemePalette: QtmPalette = {
  // Primary colors
  blue: colors.blue[300],
  darkBlue: colors.blue[500],
  lightBlue: colors.blue[100],
  lightestBlue: colors.blue[50],

  // Grays
  darkestGray: colors.gray[700],
  darkGray: colors.gray[500],
  gray: colors.gray[300],
  lightGray: colors.gray[100],

  // Supporting colors
  darkRed: colors.red[500],
  red: colors.red[300],
  lightRed: colors.red[100],
  lightestRed: colors.red[50],
  darkGreen: colors.green[500],
  green: colors.green[300],
  lightGreen: colors.green[100],
  yellow: colors.yellow[300],
  lightYellow: colors.yellow[100],
  orange: colors.orange[300],
  purple: colors.purple[300],

  contrast: {
    // Primary colors
    blue: qtmBlack,
    darkBlue: qtmBlack,
    lightBlue: qtmBlack,
    lightestBlue: qtmBlack,

    // Grays
    darkestGray: qtmWhite,
    darkGray: qtmBlack,
    gray: qtmBlack,
    lightGray: qtmBlack,

    // Supporting colors
    darkRed: qtmBlack,
    red: qtmBlack,
    lightRed: qtmBlack,
    lightestRed: qtmBlack,
    darkGreen: qtmBlack,
    green: qtmBlack,
    lightGreen: qtmBlack,
    yellow: qtmBlack,
    lightYellow: qtmBlack,
    orange: qtmBlack,
    purple: qtmBlack,
    darkAqua: qtmBlack,
    aqua: qtmBlack,
    lightAqua: qtmBlack,
  },
};

setGreyAliases(qtmDarkThemePalette);
